import { render } from "./Telegram.vue?vue&type=template&id=2e7c232a"
import script from "./Telegram.vue?vue&type=script&lang=js"
export * from "./Telegram.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/Bv4wyByn/0/ben/social-share.link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__